import "../../index84.css";
import { jsx as o } from "react/jsx-runtime";
import { useCallback as a } from "react";
import { CloseLineIcon as f, QuestionLineIcon as w, InformationLineIcon as C, ErrorWarningLineIcon as b, CheckboxCircleLineIcon as k } from "@ifrc-go/icons";
import { _ as B } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import L from "../Button/index.js";
import I from "../Container/index.js";
import y from "../IconButton/index.js";
import x from "../../hooks/useTranslation.js";
const N = "common", T = {
  alertCopyErrorDetails: "Copy error details",
  closeButtonTitle: "Close"
}, v = {
  namespace: N,
  strings: T
}, D = "_alert_n3bru_1", A = "_with-light-background_n3bru_8", E = "_icon_n3bru_13", M = "_info_n3bru_21", S = "_success_n3bru_26", V = "_danger_n3bru_31", W = "_warning_n3bru_36", n = {
  alert: D,
  withLightBackground: A,
  icon: E,
  info: M,
  success: S,
  danger: V,
  warning: W
}, j = {
  success: n.success,
  warning: n.warning,
  danger: n.danger,
  info: n.info
}, z = {
  success: /* @__PURE__ */ o(k, { className: n.icon }),
  danger: /* @__PURE__ */ o(b, { className: n.icon }),
  info: /* @__PURE__ */ o(C, { className: n.icon }),
  warning: /* @__PURE__ */ o(w, { className: n.icon })
};
function R(c) {
  const {
    name: r,
    className: l,
    type: s = "info",
    title: u,
    description: m,
    onCloseButtonClick: e,
    nonDismissable: g,
    debugMessage: t,
    withLightBackground: d,
    withoutShadow: h
  } = c, i = x(v), p = a(
    () => {
      e && e(r);
    },
    [e, r]
  ), _ = a(
    () => {
      t && navigator.clipboard.writeText(t);
    },
    [t]
  );
  return /* @__PURE__ */ o(
    I,
    {
      className: B(
        n.alert,
        j[s],
        d && n.withLightBackground,
        l
      ),
      headerIcons: z[s],
      heading: u,
      headingLevel: 5,
      headerActions: !g && /* @__PURE__ */ o(
        y,
        {
          name: void 0,
          onClick: p,
          colorVariant: "text-on-dark",
          title: i.closeButtonTitle,
          ariaLabel: i.closeButtonTitle,
          children: /* @__PURE__ */ o(f, {})
        }
      ),
      withoutWrapInHeader: !0,
      withoutWrapInFooter: !0,
      footerActions: t && /* @__PURE__ */ o(
        L,
        {
          name: void 0,
          onClick: _,
          colorVariant: "text-on-dark",
          styleVariant: "translucent",
          textSize: "sm",
          spacing: "sm",
          children: i.alertCopyErrorDetails
        }
      ),
      withPadding: !0,
      withShadow: !h,
      children: m
    }
  );
}
export {
  R as default
};
